import activityLogRoutes from 'modules/activityLog/common/routing/routes'

const routes = {
  root: `${activityLogRoutes.root}/details/apro`,
}

export default routes
